export const PROFICIENCIES = {
  "Backend Languages": {
    image: "profs-be",
    list: [
      { name: "C", devicon: "c", skipName: true },
      { name: "C++", devicon: "cplusplus", skipName: true },
      { name: "C#", devicon: "csharp", skipName: true },
      { name: "Java", devicon: "java" },
      { name: "Python", devicon: "python" },
      { name: "node.js", devicon: "nodejs" },
      { name: "Go", devicon: "go" },
    ],
  },

  "Backend Frameworks": {
    image: "profs-be-fw",
    list: [
      { name: ".NET Core", devicon: "dotnetcore" },
      { name: "Flask", devicon: "flask" },
      { name: "SQLAlchemy", devicon: "sqlalchemy" },
      { name: "Pandas", svg: "pandas" },
    ],
  },

  "Frontend Web": {
    image: "profs-web",
    list: [
      { name: "javascript", devicon: "javascript" },
      { name: "TypeScript", devicon: "typescript" },
      { name: "Angular", devicon: "angularjs" },
      { name: "React", devicon: "react" },
      { name: "Redux", devicon: "redux" },
    ],
  },

  "Frontend Desktop/Mobile": {
    image: "profs-mobile",
    list: [
      { name: "WPF", devicon: "dot-net" },
      { name: "Objective-C", devicon: "objectivec" },
      { name: "Android", devicon: "android" },
      { name: "React-Native", devicon: "react" },
    ],
  },

  "Web Server": {
    image: "profs-webserver",
    list: [
      { name: "ASP.NET", devicon: "dot-net" },
      { name: "Spring", devicon: "spring" },
      { name: "NGINX", devicon: "nginx", skipName: true },
      { name: "uWSGI", devicon: "uwsgi", skipName: true },
    ],
  },

  Tools: {
    image: "profs-tools",
    list: [
      { name: "Docker", devicon: "docker" },
      { name: "Vagrant", devicon: "vagrant" },
      { name: "git", devicon: "git" },
      { name: "TFS", devicon: "visualstudio" },
      { name: "bash", devicon: "bash" },
      { name: "Expo", svg: "expo" },
      { name: "Netlify", svg: "netlify" },
      { name: "Terraform", devicon: "terraform" },
    ],
  },

  Cloud: {
    image: "profs-cloud",
    list: [
      { name: "Amazon Web Services", devicon: "amazonwebservices" },
      { name: "Google Cloud", devicon: "googlecloud" },
      { name: "Kubernetes", devicon: "kubernetes" },
    ],
  },

  Databases: {
    image: "profs-db",
    list: [
      { name: "mySQL", devicon: "mysql" },
      { name: "SQL-Server", devicon: "microsoftsqlserver" },
      { name: "Redis", devicon: "redis" },
      { name: "rocksdb", devicon: "rocksdb" },
      { name: "FireBase", devicon: "firebase" },
      { name: "MongoDB", devicon: "mongodb" },
      { name: "Neo4j", svg: "neo4j" },
      { name: "Kafka", svg: "apachekafka" },
    ],
  },

  Design: {
    image: "profs-design",
    list: [
      { name: "Illustrator", devicon: "illustrator" },
      { name: "Photoshop", devicon: "photoshop" },
      { name: "Sketch", svg: "sketch" },
    ],
  },
};
